import Episode from "@/containers/Episode";
import Episodes from "@/containers/Episodes";
import Button from "@components/Button";
import Typography from "@components/Typography";

import { useOnboardingContext } from "../OnboardingContext";

import styles from "./Onboarding.module.css";

const Onboarding = () => {
  const { featuredMention, user } = useOnboardingContext();

  return (
    <div className={styles.root}>
      <div className={styles.textbox}>
        <Typography variant="h1" align="center">
          {L.ONBOARDING_TITLE.replace("{}", user?.first_name)}
        </Typography>
        <Typography variant="subtitle-1" align="center">
          {L.ONBOARDING_BODY_TEXT}
        </Typography>
      </div>
      {featuredMention && (
        <Episodes>
          <Episode
            className={styles.episode}
            hideActions={true}
            hideTags={true}
            hideSimilar={true}
            {...featuredMention}
            {...featuredMention?.post_data}
            // Remove the links from title and show name without any incisions in the current Episode card code.
            website_url={null}
            episode_public_url={null}
          />
        </Episodes>
      )}
      <Button href="/a" data-testid="finish-onboarding-cta">
        {L.ONBOARDING_FINISH_CTA}
      </Button>
    </div>
  );
};

export default Onboarding;
